var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimespentEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 634133"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1649_2239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#F4F4F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1649_2239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 634146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 634000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170",
    x: 68.0107,
    y: 37.2043,
    width: 32.0855,
    height: 43.9882,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167",
    x: 72.6683,
    y: 63.4697,
    width: 23.2879,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173",
    x: 72.6683,
    y: 69.717,
    width: 23.2879,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172",
    x: 72.4731,
    y: 54.1613,
    width: 23.2043,
    height: 7.13978,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171",
    x: 72.4731,
    y: 39.8817,
    width: 10.7097,
    height: 10.7097,
    rx: 5.35484,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634001"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170_2",
    x: 10,
    y: 37.2043,
    width: 32.0855,
    height: 43.9882,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167_2",
    x: 26.0645,
    y: 45.2366,
    width: 12.4946,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172_2",
    x: 13.5699,
    y: 54.1613,
    width: 24.9892,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173_2",
    x: 13.5699,
    y: 59.5161,
    width: 24.9892,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3174",
    x: 13.5699,
    y: 64.871,
    width: 24.9892,
    height: 7.13978,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171_2",
    x: 13.7651,
    y: 40.7742,
    width: 10.7097,
    height: 10.7097,
    rx: 5.35484,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.267 28.2796C76.6782 28.8961 81.3979 33.1088 81.3979 48.7608V69.3105C81.3979 83.0103 78.5717 89.8602 64.4409 89.8602H47.4839C33.3531 89.8602 30.5269 83.0103 30.5269 69.3105V48.7608C30.5269 33.143 35.2466 28.8961 44.6577 28.2796",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.267 28.2796C76.6782 28.8961 81.3979 33.1088 81.3979 48.7608V69.3105C81.3979 83.0103 78.5717 89.8602 64.4409 89.8602H47.4839C33.3531 89.8602 30.5269 83.0103 30.5269 69.3105V48.7608C30.5269 33.143 35.2466 28.8961 44.6577 28.2796",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M68.3082 58.6237C68.3082 65.1923 62.9772 70.5233 56.4086 70.5233C49.84 70.5233 44.5089 65.1923 44.5089 58.6237C44.5089 52.0551 49.84 46.724 56.4086 46.724C62.9772 46.724 68.3082 52.0551 68.3082 58.6237Z",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M60.8234 62.4077L57.1345 60.2063C56.4919 59.8255 55.9683 58.9092 55.9683 58.1596V53.2807",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.0457 34.75H62.879C69.7957 34.75 69.7957 31.2917 69.7957 27.8333C69.7957 20.9167 66.3374 20.9167 62.879 20.9167H49.0457C45.5874 20.9167 42.129 20.9167 42.129 27.8333C42.129 34.75 45.5874 34.75 49.0457 34.75Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimespentEmpty);
export default __webpack_public_path__ + "static/media/timespentEmpty.852b55d0e179ff141636b3c845533697.svg";
export { ForwardRef as ReactComponent };